import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

// Kiểm tra quyền truy cập URL (dummy, bạn có thể thay đổi theo logic thực tế)
export function checkPhanQuyenUrl(pathname, dsQuyen) {
  // Ví dụ: chỉ cho phép nếu dsQuyen chứa pathname
  return dsQuyen.includes(pathname);
}

export function AuthRoute({ isAuthProtected = false, dsQuyen = [], children }) {
  const location = useLocation();
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

  if (dsQuyen.length > 0 && !checkPhanQuyenUrl(location.pathname, dsQuyen)) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

//   if (isAuthProtected && !isLoggedIn) {
//     return <Navigate to="/login" state={{ from: location }} replace />;
//   }

  // Có thể thêm các điều kiện khác nếu cần
  return children ? children : <Outlet />;
}
